var scope_0 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9e4fafe70e235f80f37dbc8f4348c24d.js').default;
var scope_2 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7254f3e8dbf954909b258a0fe3b0ec5.js').default;
var scope_3 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc695cdc6fb3620032a399b809dedea9.js').default;
var scope_4 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f061f5595e1d8a0b5d208cc9ae945b79.js').default;
var scope_5 = require('/tmp/3e9a0424/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2ff9c38f60dc2b7864f183b785c63c7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    